/**
 * @desc 查询帮助文档详情
 */
import { HelpDocEntity } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryHelpDocParameter = {
  id?: string
}

const method = 'GET'
const url = '/content/operation/help/doc'

export const queryHelpDocApi = (
  params?: QueryHelpDocParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<HelpDocEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryHelpDocApi.method = method
queryHelpDocApi.url = url
